import React, {useState} from 'react';

import {Tab, TabContainer} from 'ui-library/TabContainer';

import {TabSection as TabSectionType} from './DataLayoutTypes';
import GridSection from './GridSection';

interface TabSectionProps {
  tabSection: TabSectionType;
}

/** @package */
export default function TabSection({tabSection}: TabSectionProps): JSX.Element {
  const [activeTab, setActiveTab] = useState<string>('0');
  return (
    <TabContainer<string> activeTab={activeTab} onRequestTabChange={setActiveTab}>
      {tabSection.tabs.map((tab, index) => (
        <Tab tabKey={index.toString()} title={tab.title} key={index}>
          <GridSection grid={tab.grid} />
        </Tab>
      ))}
    </TabContainer>
  );
}
